import { EvaluationCopyBookSearchBar } from "@/search/components/evaluation-copy/EvaluationCopyBookSearchBar";
import { Typography } from "@cappelendamm/design-system/react";
import { EvaluationCartItems } from "@/evaluation-copy/book-select-stage/EvaluationCartItems";
import { useCart } from "@/cart";
import { BookItem } from "@/search/components/types";

export const EvaluationCopyBookList = () => {
  const { cart, addItem } = useCart();

  const onSearchItemSelect = (item: BookItem) => {
    addItem({ sku: item.isbn });
  };

  return (
    <div
      className="flex flex-col gap-6 pb-4 sm:cvr-card sm:p-8"
      aria-labelledby="choose-books-heading"
    >
      <div>
        <div className="mb-4">
          <Typography variant="body-sm" className="text-gray-700">
            Søk opp og legg til bøkene du ønsker å vurdere
          </Typography>
        </div>
        <EvaluationCopyBookSearchBar onItemSelect={onSearchItemSelect} />
      </div>

      <div>
        <Typography as="h2" className="mb-3">
          Valgte produkter ({cart?.items.length || 0})
        </Typography>
        <EvaluationCartItems />
      </div>
    </div>
  );
};
